// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"975ce5a3","749":"983f5ebf","788":"6b771aa5","891":"6159f041","968":"42fa48c5"}[chunkId] + ".chunk.js";
};